export default __webpack_public_path__ + "static/media/carte_globale.506ec326.svg";